module.exports = __webpack_public_path__ + "static/media/homepage-hero3.7174247c.png";